import { React, useState } from "react";
import axios from "axios";
import PropTypes from "prop-types";
import { CreateValidateTextField } from "..";
import { Dialog, DialogTitle, Snackbar, Alert } from "@mui/material";

function ResearchAreaCreate(props) {
  const { updateTable, setUpdateTable } = props;
  const [openCreateDialog, setOpenCreateDialog] = useState(false);

  const [researchAreaName, setResearchAreaName] = useState("");

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");

  const handleResearchAreaCreate = (event) => {
    event.preventDefault();
    const body = new FormData();
    body.append("researchAreaName", researchAreaName);
    axios.post("/faculty/createResearchArea", body).then((res) => {
      const data = res.data;
      if (data.success) {
        resetHooks();
        setOpenCreateDialog(false);
        setUpdateTable(!updateTable);
      } else {
        setSnackbarMessage(data.message);
        setSnackbarOpen(true);
      }
    });
  };

  const resetHooks = () => {
    setResearchAreaName("");
  };

  function showCreateDialog() {
    return (
      <Dialog open={openCreateDialog} maxWidth={false}>
        <DialogTitle className="ResearchAreaCreate-title mx-auto text-2xl font-bold font-brand-primary mt-4">
          Create Research Area
        </DialogTitle>
        <div className="ResearchAreaCreate-modalContainer flex flex-col w-fit mb-4">
          <div className="ResearchAreaCreate-researchAreaContainer flex flex-col w-96 mx-auto mb-2">
            <div className="ResearchAreaCreate-researchArea text-lg font-brand-primary">
              Research Area *
            </div>
            <CreateValidateTextField
              placeholder="Quantum Computing"
              pattern="(?=.*\w).+"
              value={researchAreaName}
              setter={setResearchAreaName}
              errorMessage={"Invalid Research Area."}
              required={true}
            />
          </div>
          <div className="ResearchAreaCreate-buttonContainer flex justify-between px-12 mt-4">
            <button
              type="button"
              className="primary-button bg-brand-quaternary mb-2 h-11 pt-3 mr-4"
              onClick={handleResearchAreaCreate}
            >
              Create Research Area
            </button>

            <button
              type="button"
              className="primary-button bg-brand-primary mb-2 h-11 pt-3"
              onClick={() => setOpenCreateDialog(false)}
            >
              Cancel
            </button>
          </div>
        </div>
        <Snackbar
          open={snackbarOpen}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          autoHideDuration={6000}
          onClose={() => {
            setSnackbarOpen(false);
            setSnackbarMessage("");
          }
          }
        >
          <Alert
            onClose={() => {
              setSnackbarOpen(false);
              setSnackbarMessage("");
            }
            }
            severity="error"
            sx={{ width: "100%" }}
          >
            {snackbarMessage}
          </Alert>
        </Snackbar>
      </Dialog>
    );
  }

  return (
    <div className="ResearchAreaCreate-container">
      {showCreateDialog()}
      <button
        type="button"
        className="ResearchAreaCreate-button search-button px-4 h-11 mb-4 mr-4 text-center py-2"
        onClick={() => setOpenCreateDialog(true)}
      >
        Create Research Area
      </button>
    </div>
  );
}

ResearchAreaCreate.propTypes = {
  updateTable: PropTypes.bool,
  setUpdateTable: PropTypes.func,
};

ResearchAreaCreate.defaultProps = {
  updateTable: false,
  setUpdateTable: () => { },
};

export default ResearchAreaCreate;
